<ng-container
  *ngrxLet="{
    hasQuickSearchProducts: hasQuickSearchProducts$,
    didQuickSearch: didQuickSearch$,
    isLoading: isLoading$,
    isNotMobile: isNotMobile$,
    isSearchSuggestEnabled: isSearchSuggestEnabled$
  } as vm"
>
  <div class="search-bar">
    <div class="input-group">
      @if (displayBrowseMenuButton$$ | async) {
      <div class="input-group-prepend d-xl-none">
        <button
          class="btn btn-light border"
          data-e2e="filter-button"
          type="button"
          (click)="toggleAsideMenu(true)"
        >
          <fa-icon [icon]="bookmarkIcon$ | async" size="md"></fa-icon>
        </button>
      </div>
      }
      <input
        type="text"
        class="form-control search-input"
        [class.has-history-open]="inputPopover.opened"
        [style.padding-right.px]="paddingRight"
        [placeholder]="searchPlaceholder$ | async"
        [formControl]="searchInputControl"
        #input
        #inputPopover="atxPopover"
        (focus)="focusInput()"
        (atxPopoverClose)="onPopoverClosed()"
        [atxPopover]="searchSuggestion"
        [atxPopoverRepositionOnHostResize]="true"
        [popoverEnabled]="vm.isNotMobile"
        [stickWithFullWidth]="true"
        [autoClose]="true"
        [hasBackdrop]="false"
        popoverPlacement="bottom"
        componentClass="search-bar-history-list"
        data-e2e="search-input"
        (keydown.enter)="search(); input.blur(); $event.preventDefault()"
      />
      <div class="filters-container">
        @if (searchInputHasValue) {
        <button
          type="button"
          class="btn deleteIcon"
          (click)="resetSearch(); input.focus()"
        >
          <fa-icon [icon]="['fas', 'xmark']" size="xs"></fa-icon>
        </button>
        }
        <epc-search-filters
          (openSearch)="search()"
          [class.d-flex]="!(inputInFocus$ | async)"
          [class.d-none]="inputInFocus$ | async"
          class="align-items-center"
        ></epc-search-filters>

        @if (inputInFocus$ | async) {
        <button
          class="btn btn-search-assist btn-search d-flex align-items-center"
          (mousedown)="search()"
        >
          <!--Button mousedown event is used as it has more priority then blur which hide button before click event triggered-->
          <fa-icon
            class="mr-2"
            [icon]="['fas', 'magnifying-glass']"
            size="xs"
          ></fa-icon>
          <ng-container
            *ngIf="
              vm.didQuickSearch && vm.hasQuickSearchProducts;
              else pressEnter
            "
          >
            <span
              i18n="
                searchBar|Text for search bar search all button
                message@@searchBarSearchAllButton"
              >Show Everything</span
            >
          </ng-container>

          <ng-template #pressEnter>
            <span
              i18n="
                searchBar|Text for search bar search button
                message@@searchBarSearchButton"
              >Press ENTER</span
            >
          </ng-template>
        </button>
        }
      </div>
    </div>
  </div>
  <ng-template #searchSuggestion>
    <div class="search-popover" [ngClass]="{ loading: vm.isLoading }">
      @if (vm.isSearchSuggestEnabled && hasAnySuggestions() &&
      searchInputHasValue) {
      <div class="d-flex">
        <epc-search-suggest
          class="overflow-auto flex-1"
          [products]="searchSuggestResult()?.products"
          [filters]="searchSuggestFilters()"
          [autocompletes]="searchSuggestAutocomplete()"
          (onAutocompleteClick)="onAutocompleteItemClick($event); input.blur()"
          (filterItemClick)="onFilterItemClick($event); input.blur()"
          (productClick)="onSuggestProductClick($event); input.blur()"
        >
          <p
            class="text-muted mt-3 mb-0 font-weight-bold"
            i18n="
              searchBar|Text for search history@@searchBarSearchHistoryHeader"
          >
            Search History
          </p>
          <ng-container
            *ngTemplateOutlet="
              historyContainer;
              context: { showRecommendation: false }
            "
          ></ng-container>
        </epc-search-suggest>
        @if(isShowSearchSuggestBarPanel$ | async) {
        <epc-recommendation-panel
          [location]="recommendationsPanels.SearchSuggestBar"
        ></epc-recommendation-panel>
        }
      </div>
      } @else if (vm.didQuickSearch && vm.hasQuickSearchProducts &&
      searchInputHasValue) {
      <ng-container *ngIf="vm.hasQuickSearchProducts">
        <epc-products-search-list
          class="product-list pt-2 pb-3"
          [products]="quickSearchProducts$ | async"
          [showPagination]="false"
          (cardClicked)="selectProduct()"
        >
        </epc-products-search-list>
      </ng-container>
      } @else {
      <ng-container
        *ngTemplateOutlet="
          historyContainer;
          context: { showRecommendation: true }
        "
      ></ng-container>
      }

      <ng-template
        #historyContainer
        let-showRecommendation="showRecommendation"
      >
        <div class="search-history-container">
          @if (recentProducts$ | async; as recentProducts) {
          <div
            class="py-2 search-history"
            [class.present-panel]="
              (isShowSearchBarPanel$ | async) && showRecommendation
            "
          >
            <p
              class="mx-2 mt-0 mb-2 flex-1"
              *ngIf="
                vm.didQuickSearch &&
                !vm.hasQuickSearchProducts &&
                !vm.loading &&
                searchInputHasValue
              "
              i18n="
                searchBar|Text for quick search no products
                found@@quickSearchNoProducts"
            >
              No products found...
            </p>
            @for (item of searchHistory$ | async; track item) {
            <div class="history-item" (click)="search(item); input.blur()">
              <fa-icon
                [icon]="['fas', 'clock-rotate-left']"
                size="xs"
                class="history-item-icon"
              ></fa-icon>
              <span class="history-item-text text-truncate">{{ item }}</span>
              @if (findRecentProduct(recentProducts, item); as recentProduct) {
              <atx-avatar
                class="history-avatar"
                [fullName]="recentProduct.articleTitle"
                [image]="recentProduct.imageUrl"
                size="xxs"
              ></atx-avatar>
              }
            </div>
            }
          </div>
          } @if (showRecommendation) {
          <epc-recommendation-panel
            [location]="recommendationsPanels.SearchBar"
          ></epc-recommendation-panel>
          }
        </div>
      </ng-template>

      <div class="button-section pb-2">
        <button
          type="button"
          class="btn btn-primary btn-search-assist btn-search align-items-center"
          (click)="search()"
        >
          <fa-icon
            class="mr-2"
            [icon]="['fas', 'magnifying-glass']"
            size="xs"
          ></fa-icon>

          <ng-container
            *ngIf="
              vm.didQuickSearch && vm.hasQuickSearchProducts;
              else pressEnter
            "
          >
            <span
              i18n="
                searchBar|Text for search bar search all button
                message@@searchBarSearchAllButton"
              >Show Everything</span
            >
          </ng-container>
          <ng-template #pressEnter>
            <span
              i18n="
                searchBar|Text for search bar search button
                message@@searchBarSearchButton"
              >Press ENTER</span
            >
          </ng-template>
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
